<template>
    <div>
        <tinymce v-model="content" :init="tinymceInit" @change="onEditorChange" :id="editorId" />
    </div>
</template>

<script>
import { tinymce } from 'vue-tinymce-editor';
import 'tinymce/tinymce'; // 引入 TinyMCE
// import 'tinymce/themes/silver'; // 引入主题
// import 'tinymce/icons/default'; // 引入图标
import '../../../public/tinymce/langs/zh_CN'; // 引入中文语言包

export default {
    components: {
        tinymce
    },
    props: {
        editorId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            content: '',
            tinymceInit: {
                height: 300,
                menubar: false,
                language: 'zh_CN', // 设置语言为中文
                plugins: [
                    'lists link image preview',
                    'searchreplace code',
                    'table paste help'
                ],
                toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | link image | code | uploadVideo',
                setup: (editor) => {
                    editor.on('change', () => {
                        editor.save();
                    });
                }
            }
        };
    },
    methods: {
        onEditorChange(content) {
            this.content = content;
            this.$emit('input', content);
        }
    }
};
</script>

<style scoped>
/* 你可以在这里添加样式 */
</style>